export enum CardEnum {
  POPULAR = 'POPULAR',
  CATALOG = 'CATALOG',
  SHOP = 'SHOP',
  SHOP_SECTION = 'SHOP_SECTION',
  COLLECTION = 'COLLECTION'
}
